<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
unlayer.setLinkTypes([
  {
    name: "Digizone solution",
    attrs: {
      href: "https://digizonesolution.com/",
      target: "_blank"
    },
  }
]);